import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

/**
 * Erreur d'authentification (callback OIDC en échec). Le détail de l'erreur est
 * transmis via location.state par CallbackPage et affiché/loggé pour que le
 * diagnostic ne se fasse plus jamais à l'aveugle.
 */
const LoginError: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  // Compte dont toutes les plateformes sont en SSO partenaire, connecté par mot
  // de passe (PlateformeChoiceGate).
  const isPartenaire = searchParams.get('reason') === 'partenaire';
  const errorMessage = (location.state as { errorMessage?: string } | null)
    ?.errorMessage;

  useEffect(() => {
    if (errorMessage) {
      console.error('[login-error] cause :', errorMessage);
    }
  }, [errorMessage]);

  const handleRetry = () => {
    // Rediriger vers votre SSO ou page de connexion
    window.location.href = '/bord';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Erreur de connexion
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            {isPartenaire
              ? 'Votre accès à la plateforme passe par le site de votre partenaire. Connectez-vous depuis celui-ci.'
              : "Une erreur s'est produite lors de votre authentification."}
          </p>
          {errorMessage && (
            <p className="mt-3 rounded-lg bg-gray-100 px-3 py-2 font-mono text-xs text-gray-500 break-words">
              {errorMessage}
            </p>
          )}
        </div>
        <div className="mt-8 space-y-6">
          <button
            onClick={handleRetry}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Réessayer
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginError;
